
const DiscountApplyType = {
    AUTOMATIC: "AUTOMATIC",
    MANUAL: "MANUAL",
    CODE: "CODE",
};

export default DiscountApplyType;
